import { render, staticRenderFns } from "./ForbiddenGoodsTable.vue?vue&type=template&id=7939f1f4&scoped=true"
import script from "./ForbiddenGoodsTable.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsTable.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenGoodsTable.vue?vue&type=style&index=0&id=7939f1f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939f1f4",
  null
  
)

export default component.exports